import React from "react"
import { Helmet } from "react-helmet-async"

interface BreadcrumbItem {
  name: string
  url: string
}

interface BreadcrumbSEOProps {
  items: BreadcrumbItem[]
}

export const BreadcrumbSEO: React.FC<BreadcrumbSEOProps> = ({ items }) => {
  const breadcrumbStructuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url
    }))
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(breadcrumbStructuredData)}</script>
    </Helmet>
  )
}

// Predefined breadcrumb configurations for common pages
export const BreadcrumbConfigs = {
  products: [
    { name: "Home", url: "https://snapfiresystems.com/" },
    { name: "Products", url: "https://snapfiresystems.com/products" }
  ],
  castInFireCollars: [
    { name: "Home", url: "https://snapfiresystems.com/" },
    { name: "Products", url: "https://snapfiresystems.com/products" },
    { name: "Cast-In Fire Collars", url: "https://snapfiresystems.com/products/cast-in-fire-collars" }
  ],
  retrofitFireCollars: [
    { name: "Home", url: "https://snapfiresystems.com/" },
    { name: "Products", url: "https://snapfiresystems.com/products" },
    { name: "Retrofit Fire Collars", url: "https://snapfiresystems.com/products/retrofit-fire-collars" }
  ],
  gasFireCollars: [
    { name: "Home", url: "https://snapfiresystems.com/" },
    { name: "Products", url: "https://snapfiresystems.com/products" },
    { name: "Gas Fire Collars", url: "https://snapfiresystems.com/products/gas-fire-collars" }
  ],
  contact: [
    { name: "Home", url: "https://snapfiresystems.com/" },
    { name: "Contact", url: "https://snapfiresystems.com/contact" }
  ],
  distributors: [
    { name: "Home", url: "https://snapfiresystems.com/" },
    { name: "Distributors", url: "https://snapfiresystems.com/distributors" }
  ]
}
